import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationOptions } from '../../../models/modals/confirmation-options.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [NgbModule, CommonModule, FormsModule, RouterModule],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss'
})
export class ConfirmationModalComponent {
  @Input() data!: ConfirmationOptions;

  isLoading = false;
  confirmationInput = '';

  constructor(
    public modalInstance: NgbActiveModal
  ) { }

  get isConfirmDisabled(): boolean {
    if (this.data.confirmationPrompt) {
      return this.confirmationInput !== this.data.confirmationPrompt;
    }
    return false;
  }

  async handleConfirm(): Promise<void> {
    if (!this.data?.onConfirm) {
      this.modalInstance.close(true);
      return;
    }

    this.isLoading = true;
    await this.data.onConfirm();

    if (this.data.closeOnSuccess !== false) {
      this.modalInstance.close(true);
      return;
    }

    this.isLoading = false;
  }
}